'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
var index = require('../../node_modules/react-stripe-elements/es/index.js');
var v4 = require('../../node_modules/uuid/v4.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');
var FormHelperText = require('../../node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var cardElementStyleDeprecated = {
  base: {
    fontSize: '15px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    '::placeholder': {
      color: 'rgba(0, 0, 0, 0.3)'
    },
    ':focus': {
      '::placeholder': {
        color: 'rgba(0, 0, 0, 0)'
      }
    }
  },
  invalid: {
    color: '#F50057'
  }
};
var cardElementStyle = {
  base: {
    fontSize: '15px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    '::placeholder': {
      color: 'rgba(0, 0, 0, 0.54)'
    },
    ':focus': {
      '::placeholder': {
        color: 'rgba(0, 0, 0, 0)'
      }
    }
  },
  invalid: {
    color: '#F50057'
  }
};
var styles = function styles(theme) {
  return {
    backgroundFilled: {
      boxSizing: 'border-box',
      backgroundColor: theme.palette.grey[100],
      height: 55,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      padding: '7px 10px 0px 12px',
      marginBottom: -6,
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
      '&:hover': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.87)'
      }
    },
    cardNumberLabelFilled: {
      fontSize: 12,
      color: 'rgba(0, 0, 0, 0.54)',
      paddingBottom: 3
    },
    cardNumberLabel: {
      fontSize: 11,
      color: 'rgba(0, 0, 0, 0.54)',
      marginBottom: 10
    },
    cardNumberLabelDeprecated: {
      fontSize: 11,
      color: 'rgba(0, 0, 0, 0.3)',
      marginBottom: 10
    },
    cardNumberLabelFocused: {
      color: 'rgb(23, 105, 170)'
    },
    cardNumberLabelFocusedDeprecated: {
      color: 'rgb(33, 150, 243)'
    },
    cardNumberLabelError: {
      color: theme.palette.error['A400']
    },
    inputBottomBorder: {
      marginTop: 6,
      width: '100%',
      position: 'relative',
      boxSizing: 'content-box'
    },
    greyBorder: {
      width: '100%',
      position: 'absolute',
      height: 1,
      backgroundClip: 'padding-box',
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
    },
    greyBorderFilled: {
      width: '100%',
      position: 'absolute',
      height: 1,
      backgroundClip: 'padding-box'
    },
    greyBorderDeprecated: {
      width: '100%',
      position: 'absolute',
      height: 1,
      backgroundClip: 'padding-box',
      borderBottom: '1px solid rgb(224,224,224)'
    },
    focusBorder: {
      width: '100%',
      position: 'absolute',
      transform: 'scaleX(0)',
      transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
      borderBottom: '1px solid rgb(33, 150, 243)'
    },
    focusBorderDeprecated: {
      width: '100%',
      position: 'absolute',
      height: 2,
      backgroundColor: 'rgb(33, 150, 243)',
      transform: 'scaleX(0)',
      transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms'
    },
    focusBorderActive: {
      transform: 'scaleX(1)'
    },
    errorBorder: {
      width: '100%',
      position: 'absolute',
      height: 2,
      backgroundColor: theme.palette.error['A400']
    },
    errorText: {
      marginTop: 15,
      color: '#F50057'
    }
  };
};
function wrapStripeElement() {
  'stripe-element-' + v4();
  return function (WrappedComponent) {
    var WrappedStripeElement =
    /*#__PURE__*/
    function (_PureComponent) {
      inherits(WrappedStripeElement, _PureComponent);

      function WrappedStripeElement(props) {
        var _this;

        classCallCheck(this, WrappedStripeElement);

        _this = possibleConstructorReturn(this, getPrototypeOf(WrappedStripeElement).call(this, props));
        _this.state = {
          focused: false
        };
        return _this;
      }

      createClass(WrappedStripeElement, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          return React__default["default"].createElement("div", null, React__default["default"].createElement("div", {
            className: this.props.variant === 'filled' ? this.props.classes.backgroundFilled : ''
          }, React__default["default"].createElement(Typography["default"], {
            type: "caption",
            className: this.labelClass()
          }, this.props.labelName), React__default["default"].createElement(WrappedComponent, {
            onChange: this.props.onChange,
            onFocus: function onFocus() {
              _this2.setState({
                focused: true
              });
            },
            onBlur: function onBlur() {
              _this2.setState({
                focused: false
              });
            },
            placeholder: this.props.placeholder,
            deprecated: this.props.deprecated,
            value: this.props.value
          })), this.inputBottomBorder(), ObjectHelper.isPresent(this.props.errorMessage) && React__default["default"].createElement(FormHelperText["default"], {
            error: true,
            className: this.props.classes.errorText
          }, this.props.errorMessage));
        }
      }, {
        key: "labelClass",
        value: function labelClass() {
          var className = '';

          if (this.props.variant === 'filled') {
            className = this.props.classes.cardNumberLabelFilled;
          } else {
            className = this.props.deprecated ? this.props.classes.cardNumberLabelDeprecated : this.props.classes.cardNumberLabel;
          }

          if (this.props.errorMessage) {
            className = "".concat(className, " ").concat(this.props.classes.cardNumberLabelError);
          } else if (this.state.focused) {
            className = "".concat(className, " ").concat(this.props.deprecated ? this.props.classes.cardNumberLabelFocusedDeprecated : this.props.classes.cardNumberLabelFocused);
          }

          return className;
        }
      }, {
        key: "inputBottomBorder",
        value: function inputBottomBorder() {
          var greyBorderClass = '';

          if (this.props.variant === 'filled') {
            greyBorderClass = this.props.classes.greyBorderFilled;
          } else {
            greyBorderClass = this.props.deprecated ? this.props.classes.greyBorderDeprecated : this.props.classes.greyBorder;
          }

          var focusBorderClass = this.props.deprecated ? this.props.classes.focusBorderDeprecated : this.props.classes.focusBorder;

          if (this.state.focused) {
            focusBorderClass = "".concat(focusBorderClass, " ").concat(this.props.classes.focusBorderActive);
          }

          return React__default["default"].createElement("div", {
            className: this.props.classes.inputBottomBorder
          }, React__default["default"].createElement("div", {
            className: greyBorderClass
          }), React__default["default"].createElement("div", {
            className: ObjectHelper.isPresent(this.props.errorMessage) ? this.props.classes.errorBorder : focusBorderClass
          }));
        }
      }]);

      return WrappedStripeElement;
    }(React.PureComponent);

    return WrappedStripeElement;
  };
}

var PureMaterialCardElement =
/*#__PURE__*/
function (_PureComponent2) {
  inherits(PureMaterialCardElement, _PureComponent2);

  function PureMaterialCardElement() {
    classCallCheck(this, PureMaterialCardElement);

    return possibleConstructorReturn(this, getPrototypeOf(PureMaterialCardElement).apply(this, arguments));
  }

  createClass(PureMaterialCardElement, [{
    key: "render",
    value: function render() {
      return React__default["default"].createElement(index.CardElement, {
        onChange: this.props.onChange,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        style: this.props.deprecated ? cardElementStyleDeprecated : cardElementStyle
      });
    }
  }]);

  return PureMaterialCardElement;
}(React.PureComponent);

var MaterialCardElement = withStyles(styles)(wrapStripeElement()(PureMaterialCardElement));

var PureMaterialPostalCodeElement =
/*#__PURE__*/
function (_PureComponent3) {
  inherits(PureMaterialPostalCodeElement, _PureComponent3);

  function PureMaterialPostalCodeElement() {
    classCallCheck(this, PureMaterialPostalCodeElement);

    return possibleConstructorReturn(this, getPrototypeOf(PureMaterialPostalCodeElement).apply(this, arguments));
  }

  createClass(PureMaterialPostalCodeElement, [{
    key: "render",
    value: function render() {
      return React__default["default"].createElement(index.PostalCodeElement, {
        onChange: this.props.onChange,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        style: this.props.deprecated ? cardElementStyleDeprecated : cardElementStyle,
        placeholder: this.props.placeholder,
        value: this.props.value
      });
    }
  }]);

  return PureMaterialPostalCodeElement;
}(React.PureComponent);

var MaterialPostalCodeElement = withStyles(styles)(wrapStripeElement()(PureMaterialPostalCodeElement));

var PureMaterialCardExpiryElement =
/*#__PURE__*/
function (_PureComponent4) {
  inherits(PureMaterialCardExpiryElement, _PureComponent4);

  function PureMaterialCardExpiryElement() {
    classCallCheck(this, PureMaterialCardExpiryElement);

    return possibleConstructorReturn(this, getPrototypeOf(PureMaterialCardExpiryElement).apply(this, arguments));
  }

  createClass(PureMaterialCardExpiryElement, [{
    key: "render",
    value: function render() {
      return React__default["default"].createElement(index.CardExpiryElement, {
        onChange: this.props.onChange,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        style: this.props.deprecated ? cardElementStyleDeprecated : cardElementStyle,
        placeholder: this.props.placeholder,
        value: this.props.value
      });
    }
  }]);

  return PureMaterialCardExpiryElement;
}(React.PureComponent);

var MaterialCardExpiryElement = withStyles(styles)(wrapStripeElement()(PureMaterialCardExpiryElement));
var PureMaterialCardCVCElement =
/*#__PURE__*/
function (_PureComponent5) {
  inherits(PureMaterialCardCVCElement, _PureComponent5);

  function PureMaterialCardCVCElement() {
    classCallCheck(this, PureMaterialCardCVCElement);

    return possibleConstructorReturn(this, getPrototypeOf(PureMaterialCardCVCElement).apply(this, arguments));
  }

  createClass(PureMaterialCardCVCElement, [{
    key: "render",
    value: function render() {
      return React__default["default"].createElement(index.CardCVCElement, {
        onChange: this.props.onChange,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        style: this.props.deprecated ? cardElementStyleDeprecated : cardElementStyle,
        placeholder: this.props.placeholder,
        value: this.props.value
      });
    }
  }]);

  return PureMaterialCardCVCElement;
}(React.PureComponent);
var MaterialCardCVCElement = withStyles(styles)(wrapStripeElement()(PureMaterialCardCVCElement));
var PureMaterialCardNumberElement =
/*#__PURE__*/
function (_PureComponent6) {
  inherits(PureMaterialCardNumberElement, _PureComponent6);

  function PureMaterialCardNumberElement() {
    classCallCheck(this, PureMaterialCardNumberElement);

    return possibleConstructorReturn(this, getPrototypeOf(PureMaterialCardNumberElement).apply(this, arguments));
  }

  createClass(PureMaterialCardNumberElement, [{
    key: "render",
    value: function render() {
      return React__default["default"].createElement(index.CardNumberElement, {
        onChange: this.props.onChange,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        style: this.props.deprecated ? cardElementStyleDeprecated : cardElementStyle,
        placeholder: this.props.placeholder,
        value: this.props.value
      });
    }
  }]);

  return PureMaterialCardNumberElement;
}(React.PureComponent);
var MaterialCardNumberElement = withStyles(styles)(wrapStripeElement()(PureMaterialCardNumberElement));

exports.MaterialCardCVCElement = MaterialCardCVCElement;
exports.MaterialCardExpiryElement = MaterialCardExpiryElement;
exports.MaterialCardNumberElement = MaterialCardNumberElement;
exports.MaterialPostalCodeElement = MaterialPostalCodeElement;
exports.PureMaterialCardCVCElement = PureMaterialCardCVCElement;
exports.PureMaterialCardNumberElement = PureMaterialCardNumberElement;
exports["default"] = MaterialCardElement;
exports.styles = styles;
exports.wrapStripeElement = wrapStripeElement;
